<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/J02oJV/tc-custom/9781644031780.jpg?1732163600206" alt="This image is the cover for the book Show Me How to Paper Piece"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Show Me How to Paper Piece
      </h1>
      <p class="bookDescription body article font2">
        <p>Quick &amp; easy and paper-piecing method! Learn the basics of paper-piecing with renowned teacher Carol Doak. Beginners leap into quilting and create your first paper-pieced quilt with thorough instructions and guided visuals to help achieve a perfect, accurate block. Create your own wall quilt by sewing blocks that can be completed in 3 simple steps! Step-by-step instructions for perfect blocks every time  Guided by expert quilter and best-selling author Carol Doak Easy for all skill levels! First-time quilters can achieve accurate blocks</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carol Doak
      </h2>
      
      <p class="authorDescription body article">Carol Doak is a pioneer in the area of paper foundation piecing. She has published over a dozen successful books and earned many honors in the quilting industry. Carol lives in Bonita Springs, Florida. caroldoak.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Published by C&T Publishing, Inc.,
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?605da20e